export const festivalDustAppMarquee = [
  {
    title: 'Home',
    imgLink: '/festival-dust/marquee/home.png',
  },
  {
    title: 'Group Home',
    imgLink: '/festival-dust/marquee/group-home.png',
  },
  {
    title: 'Festival Home',
    imgLink: '/festival-dust/marquee/festival-home.png',
  },
  {
    title: 'Schedule',
    imgLink: '/festival-dust/marquee/schedule.png',
  },
]

export const festivalDustAppMarqueeMobile = [
  {
    title: 'Home',
    imgLink: '/festival-dust/new-mobile-marquee/home.png',
  },
  {
    title: 'Favorites',
    imgLink: '/festival-dust/new-mobile-marquee/favorites.png',
  },
  {
    title: 'Festival Home',
    imgLink: '/festival-dust/new-mobile-marquee/festival_home.png',
  },
  {
    title: 'Artists Home',
    imgLink: '/festival-dust/new-mobile-marquee/artists_home.png',
  },
  {
    title: 'Festival Updates',
    imgLink: '/festival-dust/new-mobile-marquee/festival_updates.png',
  },
  {
    title: 'Group Home',
    imgLink: '/festival-dust/new-mobile-marquee/group_home.png',
  },
  {
    title: 'Group Schedule',
    imgLink: '/festival-dust/new-mobile-marquee/group_schedule.png',
  },
  {
    title: 'Paywall',
    imgLink: '/festival-dust/new-mobile-marquee/paywall.png',
  },
  {
    title: 'Profile',
    imgLink: '/festival-dust/new-mobile-marquee/profile.png',
  },
  {
    title: 'Schedule',
    imgLink: '/festival-dust/new-mobile-marquee/schedule.png',
  },
  {
    title: 'Lockscreen Creator',
    imgLink: '/festival-dust/new-mobile-marquee/screenshot_home.png',
  },
]

export const festivalDustWebMarquee = [
  {
    title: 'Home',
    imgLink: '/festival-dust/web-marquee/home.png',
  },
  {
    title: 'Festival Lineup',
    imgLink: '/festival-dust/web-marquee/lineup.png',
  },
  {
    title: 'Festival Schedule',
    imgLink: '/festival-dust/web-marquee/schedule.png',
  },
]